import type { Control } from 'react-hook-form';
import type { IntlShape } from 'react-intl';

import type { ImportOrderFormData } from '#features/csvImport/ImportOrderFormValidation.ts';

import { ControlSize } from '../../form/ControlSize.ts';
import { ControlledFormInput } from '../../form/FormInput.tsx';
import type { OrderFormData } from './OrderFormValidation.ts';

export const CustomerInput = ({
    intl,
    control,
    namePrefix,
}: {
    intl: IntlShape;
    control: Control<OrderFormData> | Control<ImportOrderFormData>;
    namePrefix?: string;
}) => {
    const name = namePrefix ? `${namePrefix}.customerName` : 'customerName';
    return (
        <ControlledFormInput
            label={intl.formatMessage({
                id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.step1.customer',

                defaultMessage: 'Customer',
            })}
            name={name}
            rioglyph={'user'}
            control={control}
            size={ControlSize.LARGE}
        />
    );
};
